import { Users } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, deleteData, encryptPassword, sanitizeInput } from "../CommonComponents/CustomHooks";
import { initializeFilterData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const StateMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false)
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const initialFormData = {
        "stateCode": "",
        "stateName": "",
        "stateID": "",
        "countryCode": "",
        "active": true,
    }

    const [formData, setFormData] = useState(initialFormData);

    const GetStateMaster = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let data = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowStateMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED' || res.Status === 'UNAUTHORIZED') {
            await NotificationSound(res.Status, res.Message, res?.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData(initialFormData);
        filterData.SearchText = '';
        inputrefs.current['txtCountryCode'].focus()
        setIsEdit(false)
        GetStateMaster();
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateStateMaster`, { ...formData, password: encryptPassword(formData.password) })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data?.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        await setIsEdit(true);
        let editData = await ApiCall(`/api/Master/EditStateMaster`, { stateID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'SUCCESS') {
            setFormData((pre) => ({
                ...pre, ...editData,
            }))
        } else {
            await NotificationSound(editData.status, editData.message, editData?.focus, inputrefs);
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteStateMaster`, { stateID: id }, GetStateMaster, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (i, p) => {
        GetStateMaster(p)
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    useEffect(() => {
        document.title = `State Master`
        inputrefs.current['txtCountryCode'].focus()
    }, [])


    useEffect(() => {
        GetStateMaster();
    }, [sortConfig]);

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-md p-3'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-3">
                        <Users className="w-5 h-5 text-primary-600" />
                        <h2 className="text-xl font-semibold text-primary-600">State Master</h2>
                    </div>
                </div>
                <div className="card-body grid grid-cols-1 md:grid-cols-4 gap-3">
                    <AutoCompleteBoxNew
                        id="txtCountryCode"
                        label="Country"
                        required={true}
                        placeholder="Enter Country"
                        autocompleteType="GetCountry"
                        value={formData.countryCode}
                        onChange={(e, val) =>
                            setFormData({ ...formData, countryCode: val || "" })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtStateCode'].focus()
                            }
                        }}
                    />
                    <InputBox
                        id="txtStateCode"
                        label="State Code"
                        maxLength='2'
                        required={true}
                        disabled={isEdit}
                        placeholder="Enter State Code"
                        value={formData.stateCode}
                        onChange={(e) =>
                            setFormData({ ...formData, stateCode: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtStateName'].focus()
                            }
                        }}
                    />
                    <InputBox
                        id="txtStateName"
                        label="State Name"
                        placeholder="Enter State Name"
                        required={true}
                        value={formData.stateName}
                        onChange={(e) =>
                            setFormData({ ...formData, stateName: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtActive'].focus()
                            }
                        }}
                    />

                    <Switch
                        id="txtActive"
                        label="active"
                        checked={formData.active}
                        onChange={(e) =>
                            setFormData({ ...formData, active: e.target.checked })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnSub'].focus()
                            }
                        }}
                        divclassname="mt-2 ms-2"
                    />
                </div>
                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        handleSubmit={handleSubmit}
                        handleExport={async () => {
                            await dispatch(setSubLoading(true))
                            handleDownloadExcel(`/api/Master/ShowStateMaster`, filterData, 'State Master')
                            await dispatch(setSubLoading(false))
                        }}
                        handleClear={handleClear}
                    />
                </div>
            </div>
            <div className="mt-3">
                <Table
                    handleEdit={handleEditData}
                    handleDelete={handleDelete}
                    loading={isLoading}
                    PageName={'StateMaster'}
                    handleFilter={() => {
                        GetStateMaster()
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    sortConfig={sortConfig}
                    handleSorting={handleSorting}
                />
            </div>
        </>
    )
}
export default StateMaster;